import React from 'react'
import { Provider } from 'react-redux'
import { ApolloProvider } from '@apollo/client'
import { HistoryRouter } from './HistoryRouter' // The file we just made
import client from '../apollo/client'

const AppProviders = ({ store, history, children }) => {
  if (!store || !history) return null;

  return (
    <Provider store={store}>
      <HistoryRouter history={history}>
        <ApolloProvider client={client}>
          {children}
        </ApolloProvider>
      </HistoryRouter>
    </Provider>
  )
}

export default AppProviders
